import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}/auth`;

export interface LoginRequest {
  email: string;
  password: string;
}

export interface RegisterRequest {
  username: string;
  password: string;
  email: string;
  roles?: string[];
  captcha?: string;
}

export interface ForgotPasswordRequest {
  email: string;
}

export interface VerifyOtpRequest {
  email: string;
  otp: number;
}

export interface ResetPasswordRequest {
  email: string;
  newPassword: string;
}

export interface AuthResponse {
  token: string;
  tokenType: string | null;
  id: number;
  username: string;
  email: string;
  schoolId: number | null;
  roles: string[];
  role?: string; // Duplicate field sent by backend (will be removed in frontend)
}

export interface ApiResponse<T = any> {
  data: T;
  status: number;
  message?: string;
}

export const authService = {
  async login(credentials: LoginRequest): Promise<ApiResponse<AuthResponse>> {
    const response = await axios.post(`${API_URL}/login`, credentials);
    return {
      data: response.data,
      status: response.status,
      message: response.data?.message || "Login successful"
    };
  },

  async register(userData: RegisterRequest): Promise<ApiResponse<AuthResponse>> {
    const response = await axios.post(`${API_URL}/register`, userData, {
      withCredentials: true
    });
    return {
      data: response.data,
      status: response.status,
      message: response.data?.message || "Registration successful"
    };
  },

  async forgotPassword(email: string): Promise<ApiResponse<string>> {
    const response = await axios.post(`${API_URL}/forgotPass`, null, {
      params: { email }
    });
    return {
      data: response.data,
      status: response.status,
      message: response.data?.message || "OTP sent successfully"
    };
  },

  async verifyOtp(email: string, otp: number): Promise<ApiResponse<string>> {
    const response = await axios.post(`${API_URL}/verifyOtp`, null, {
      params: { email, otp }
    });
    return {
      data: response.data,
      status: response.status,
      message: response.data?.message || "OTP verified successfully"
    };
  },

  async resetPassword(email: string, newPassword: string): Promise<ApiResponse<string>> {
    const response = await axios.post(`${API_URL}/resetPassword`, {
      email,
      password: newPassword
    });
    return {
      data: response.data,
      status: response.status,
      message: response.data?.message || "Password reset successfully"
    };
  }
};
